// @flow

import { handleActions } from 'redux-actions'
import type { InteractionCapabilitiesActions } from './actions'
export type InteractionCapabilities = {
  +touch: boolean,
  +hover: boolean
}

const reducer: (
  state: InteractionCapabilities,
  action: InteractionCapabilitiesActions
) => InteractionCapabilities = handleActions(
  {
    'INTERACTION_CAPABILITIES/TOUCH/SET': (state, { payload }) => {
      return {
        ...state,
        touch: payload
      }
    },
    'INTERACTION_CAPABILITIES/HOVER/SET': (state, { payload }) => {
      return {
        ...state,
        hover: payload
      }
    }
  },
  {
    touch: false,
    hover: false
  }
)

export default reducer
